import { render, staticRenderFns } from "./OracleSendOrderSuccess.vue?vue&type=template&id=f9b23178&scoped=true"
import script from "./OracleSendOrderSuccess.vue?vue&type=script&lang=js"
export * from "./OracleSendOrderSuccess.vue?vue&type=script&lang=js"
import style0 from "./OracleSendOrderSuccess.vue?vue&type=style&index=0&id=f9b23178&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b23178",
  null
  
)

export default component.exports